import {until} from 'lit-html/directives/until';
import {repeat} from 'lit-html/directives/repeat';
import {sdoNs} from '@modules/constants-enumerate';
import '@modules/ems-collapse';
import '@modules/search-pagination';
import '@modules/data-table';
import '@modules/search-form';
import {generalAriaLabels, noSearchResults} from '@modules/i18n-labels';
import '../license-info-row';
import datatableCss from './datatable-styles.css';
import {wrapUnsafeHtml} from '@modules/wrap-unsafe-html';

const renderNoResults = (ctx, html) => {
  if (ctx.loading) {
    return html`<div class="text-center m-5 p-5"><loading-ellipses></loading-ellipses></div>`;
  }

  if (ctx.licenseAllocations.length > 0) {
    return;
  }

  return html`<p class="text-center text-muted mt-2 pt-5">${until(noSearchResults)}</p>`;
};

export default (ctx, html) => html`
<h2 class="h4 pt-5">${until(ctx.__('<tt-zzVduTzs>', 'Inventory Drilldown'))}</h2>
<ol class="list-unstyled font-weight-bold" id="lower-tiers-breakdown">
  <li class="d-inline-block"><button class="btn btn-link" @click="${(e) => ctx.navThroughBreadcrumbs(ctx.currentRole, 0)}">${ctx.currentRole.group_name}</button></li>
  ${repeat(ctx.allocationDrilldown, (group) => group, (group, index) => html`
    <li class="d-inline-block"><i class="ai-chevron-right ai"></i><button class="btn btn-link" @click="${(e) => ctx.navThroughBreadcrumbs(group, index + 1)}">${group.group_name}</button></li>
  `)}
</ol>
<div class="card shadow-sm py-4 rounded border-0 mb-5">
  <div class="border-bottom px-4 pb-3">
    <license-info-row class="border-dashed-bottom pb-3 mb-3" .row="${{
      groupName: ctx.activeRow?.group_name,
      total: ctx.currentGroupLicenseCount?.total,
      assigned: ctx.currentGroupLicenseCount?.assigned,
      unassigned: ctx.currentGroupLicenseCount?.available,
      redeemed: ctx.currentGroupLicenseCount?.redeemed,
    }}" ?loading="${ctx.loading}"></license-info-row>
    <license-info-row .row="${{
      label: until(ctx.__('<tt-wgqzy2xy>', 'Given to Lower Levels:')),
      total: ctx.childGroupLicenseCount?.total,
      assigned: ctx.childGroupLicenseCount?.assigned,
      unassigned: ctx.childGroupLicenseCount?.available,
      redeemed: ctx.childGroupLicenseCount?.redeemed,
    }}" ?loading="${ctx.loading}"></license-info-row>
  </div>
  <div class="px-4 py-3">
    <license-info-row class="font-weight-bold" .row="${{
      label: until(ctx.__('<tt-6ep8YM0H>', 'All Licenses:')),
      total: ctx.currentGroupLicenseCount?.total + ctx.childGroupLicenseCount?.total,
      assigned: ctx.currentGroupLicenseCount?.assigned + ctx.childGroupLicenseCount?.assigned,
      unassigned: ctx.currentGroupLicenseCount?.available + ctx.childGroupLicenseCount?.available,
      redeemed: ctx.currentGroupLicenseCount?.redeemed + ctx.childGroupLicenseCount?.redeemed
    }}" ?loading="${ctx.loading}"></license-info-row>
  </div>
</div>

<search-form class="mb-3"
  search-namespace="${sdoNs.LICENSE_INVENTORY_ALLOCATION}"
  placeholder="${until(ctx.tierLabels[ctx.level] ? ctx.i18n._r(ctx.i18n.__('<tt-1D2cSTe3>', 'Search %r1%'), ctx.tierLabels[ctx.level]) : ctx.i18n.__('<tt-qRjcoVpR>', 'Search Classroom'))}"
  .search="${ctx.search.bind(ctx)}">
</search-form>
${ctx.loading ?
    `` :
    html`
      <data-table
        class="text-center"
        disable-selection
        .config=${ctx.tableConfig}
        .results=${ctx.licenseAllocations}
        @row-click=${ctx.onSelect}
        @change-sort=${ctx.onSort}
        .styles="${[datatableCss]}"
        aria-label="${until(generalAriaLabels.LICENSE_INVENTORY)}"
      ></data-table>
`}

${renderNoResults(ctx, html)}

<div class="d-flex d-column justify-content-around">
  <search-pagination
    @change-page="${ctx.search}"
    disable-routing="${true}"
    search-namespace="${sdoNs.LICENSE_INVENTORY_ALLOCATION}"></search-pagination>
</div>
`;
